import { useAuth } from "@/context/AuthContext";
import { RoleBadge } from "@/components/common/RoleBadge";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { LogOut, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import logo from "@/assets/freshezy-logo.webp";

export function Topbar({ title }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const initials = (user?.name || "U").split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-stone-200 bg-white/90 px-6 backdrop-blur">
      <div className="flex min-w-0 items-center gap-3">
        <img src={logo} alt="Freshezy" className="h-9 w-9 shrink-0 rounded-md border border-stone-200 bg-white object-contain p-0.5" />
        <div className="min-w-0">
          <div className="text-[11px] font-medium uppercase tracking-wider text-amber-700/80">Freshezy Foodtech Pvt Ltd</div>
          <div className="truncate font-display text-base font-semibold text-stone-800">{title}</div>
        </div>
      </div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button data-testid="user-menu-trigger" className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-stone-100">
            <Avatar className="h-8 w-8">
              <AvatarFallback className="bg-amber-700 text-xs font-semibold text-white">{initials}</AvatarFallback>
            </Avatar>
            <div className="hidden text-left sm:block">
              <div className="text-sm font-medium leading-tight text-stone-800">{user?.name}</div>
              <div className="text-[11px] text-muted-foreground">{user?.designation || user?.department}</div>
            </div>
            <ChevronDown className="h-4 w-4 text-stone-400" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56 bg-white">
          <DropdownMenuLabel className="flex flex-col gap-1">
            <span className="text-sm">{user?.name}</span>
            <span className="text-xs font-normal text-muted-foreground">{user?.email}</span>
            <div className="pt-1"><RoleBadge role={user?.role} /></div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="btn-logout" onClick={handleLogout} className="text-rose-600 focus:text-rose-700">
            <LogOut className="mr-2 h-4 w-4" /> Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
}
